import { createSlice, configureStore, current } from '@reduxjs/toolkit'


const addressSlice = createSlice({
    name: 'address',
    initialState: {
        addressInfo: {}
    },
    reducers: {
        addAddress: (state, action) => {
            state.addressInfo = [action.payload]
        },
        clearAddress: (state, action) => {
            state.addressInfo = {}
        },
    }
})

export const { addAddress, clearAddress } = addressSlice.actions
export default addressSlice